<template>
    <li class="flex items-center p-1">
        <button
            @mouseover="hovered = true"
            @mouseleave="hovered = false"
            @click="share()"
            class="flex bg-stone-300 md:bg-ocean-900 text-white rounded-full md:opacity-25 md:hover:opacity-100 p-2 transition-opacity duration-300 ease-in-out-quad"
        >
            <svg v-if="action === 'facebook'" class="flex w-3 h-3 fill-current" viewBox="0 0 192 384">
                <path
                    d="M128 128V89.9c0-17.2 3.8-25.9 30.5-25.9H192V0h-55.9C67.6 0 45 31.4 45 85.3V128H0v64h45v192h83V192h56.4l7.6-64h-64z"
                />
            </svg>

            <svg v-else-if="action === 'twitter'" class="flex w-3 h-3 fill-current" viewBox="0 0 512 512">
                <path
                    d="M492 109.5c-17.4 7.7-36 12.9-55.6 15.3 20-12 35.4-31 42.6-53.6-18.7 11.1-39.4 19.2-61.5 23.5C399.8 75.8 374.6 64 346.8 64c-53.5 0-96.8 43.4-96.8 96.9 0 7.6.8 15 2.5 22.1-80.5-4-151.9-42.6-199.6-101.3-8.3 14.3-13.1 31-13.1 48.7 0 33.6 17.2 63.3 43.2 80.7-16-.4-31-4.8-44-12.1v1.2c0 47 33.4 86.1 77.7 95-8.1 2.2-16.7 3.4-25.5 3.4-6.2 0-12.3-.6-18.2-1.8 12.3 38.5 48.1 66.5 90.5 67.3-33.1 26-74.9 41.5-120.3 41.5-7.8 0-15.5-.5-23.1-1.4C62.8 432 113.7 448 168.3 448 346.6 448 444 300.3 444 172.2c0-4.2-.1-8.4-.3-12.5C462.6 146 479 129 492 109.5z"
                />
            </svg>

            <svg v-else-if="action === 'copylink'" class="flex w-3 h-3 fill-current" viewBox="0 0 12 12">
                <path
                    d="m1.872 5.016c.288-.288.72-.288 1.008 0s.288.72 0 1.008l-.792.864c-.432.36-.648.936-.648 1.512s.216 1.152.648 1.584c.792.792 2.232.792 3.024 0l.864-.864c.288-.288.72-.36 1.008-.072s.288.72 0 1.008l-.864.864c-.648.72-1.584 1.08-2.52 1.08s-1.872-.36-2.52-1.08c-.72-.648-1.08-1.584-1.08-2.52s.36-1.872 1.08-2.52zm5.21187097-1.18374194c.30967742-.30967741.77419355-.30967741 1.08387097 0 .30967741.30967742.30967741.77419355 0 1.08387097l-3.25161291 3.25161291c-.15483871.15483871-.38709677.23225806-.54193548.23225806s-.38709678-.07741935-.54193549-.23225806c-.30967741-.30967742-.30967741-.77419355 0-1.08387097zm1.31612903-3.83225806c.936 0 1.872.36 2.52 1.08.72.648 1.08 1.584 1.08 2.52s-.36 1.872-1.008 2.52l-.864.864c-.144.144-.36.216-.504.216s-.36-.072-.504-.216c-.288-.288-.288-.72 0-1.008l.792-.864c.432-.36.648-.936.648-1.512s-.216-1.152-.648-1.584c-.792-.792-2.232-.792-3.024 0l-.864.864c-.288.288-.72.288-1.008 0s-.288-.72 0-1.008l.864-.792c.648-.72 1.584-1.08 2.52-1.08z"
                />
            </svg>
        </button>

        <div
            class="hidden md:block text-ocean-900 font-display text-xs select-none whitespace-no-wrap ml-3 transition-all duration-300 ease-in-out-quad"
            :class="hovered ? 'opacity-100 transform translate-y-0' : 'opacity-0 translate-y-4'"
        >
            {{ text }}
        </div>
    </li>
</template>

<script>
export default {
    props: ['action', 'url', 'tooltip'],

    data() {
        return {
            text: null,
            hovered: false
        };
    },

    mounted() {
        this.text = this.tooltip;
    },

    methods: {
        share() {
            if (this.action === 'copylink') {
                this.linkCopy();
            } else {
                this.openWindow();
            }
        },

        openWindow() {
            const param = 'width=500,height=400,resizable=true';
            window.open(this.url, 'Share Article', param).focus();
        },

        linkCopy() {
            this.text = 'Copied!';
            this.$copyText(this.url);
        }
    }
};
</script>
